import { createErrorsStore } from "@/utils/create-errors-store";

export type BankDetailsErrorsStore = {
  account_holder: null | string;
  account_number: null | string;
  sort_code: null | string;
  start_date: null | string;
};

const initialErrors: BankDetailsErrorsStore = {
  account_holder: null,
  account_number: null,
  sort_code: null,
  start_date: null,
};

export const useBankDetailsErrorsStore =
  createErrorsStore<BankDetailsErrorsStore>(initialErrors);
